import { render, staticRenderFns } from "./LoginOwner.vue?vue&type=template&id=23c24cef&lang=true"
import script from "./LoginOwner.vue?vue&type=script&lang=js"
export * from "./LoginOwner.vue?vue&type=script&lang=js"
import style0 from "./LoginOwner.vue?vue&type=style&index=0&id=23c24cef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports